import { render, staticRenderFns } from "./mccCideHuifu.vue?vue&type=template&id=78472950&scoped=true&"
import script from "./mccCideHuifu.vue?vue&type=script&lang=js&"
export * from "./mccCideHuifu.vue?vue&type=script&lang=js&"
import style0 from "./mccCideHuifu.vue?vue&type=style&index=0&id=78472950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78472950",
  null
  
)

export default component.exports